<kt-portlet class="kt-portlet--height-fluid w-100">
  <kt-portlet-header [title]="'User profile'">
    <ng-container ktPortletTools> </ng-container>
  </kt-portlet-header>

  <kt-portlet-body>
    <kt-profile-notice></kt-profile-notice>

    <ngb-tabset>
      <ngb-tab title="{{ 'PROFILE.TABS.PROFILE' | transloco }}">
        <ng-template ngbTabContent>
          <form class="kt-login__form kt-form" [formGroup]="profileForm" autocomplete="off">
            <div class="col-md-8 offset-md-2 d-flex justify-content-center">
              <div class="avatar d-flex justify-content-center align-items-center" [style]="avatarStyle | async">
                <kt-icon
                  *ngIf="!user"
                  icon="/assets/icons/default_avatar_icon.svg"
                  iconType="svg"
                  height="56"
                  width="56"
                >
                </kt-icon>

                <kt-icon
                  class="plus-icon"
                  icon="/assets/icons/plus_icon_blue.svg"
                  iconType="svg"
                  height="40"
                  width="40"
                  placement="bottom"
                  ngbTooltip="Change user avatar"
                  (click)="selectAvatar()"
                >
                </kt-icon>

                <input type="file" class="hidden-file" accept="image/*" #avatarInput formControlName="avatar" />
              </div>
            </div>

            <div class="form-group">
              <mat-form-field>
                <mat-label>{{ 'PROFILE.INPUT.FIRST_NAME' | transloco }}</mat-label>
                <input
                  matInput
                  type="text"
                  placeholder="{{ 'PROFILE.INPUT.FIRST_NAME' | transloco }}"
                  formControlName="firstName"
                />
                <mat-error *ngIf="isControlHasError('firstName', 'required')">
                  <strong>{{ 'VALIDATION.REQUIRED_FIELD' | transloco }}</strong>
                </mat-error>
                <mat-error *ngIf="isControlHasError('firstName', 'minlength')">
                  <strong>{{ 'VALIDATION.MIN_LENGTH_FIELD' | transloco }} 3</strong>
                </mat-error>
                <mat-error *ngIf="isControlHasError('firstName', 'maxlength')">
                  <strong>{{ 'VALIDATION.MAX_LENGTH_FIELD' | transloco }} 100</strong>
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field>
                <mat-label>{{ 'PROFILE.INPUT.LAST_NAME' | transloco }}</mat-label>
                <input
                  matInput
                  type="text"
                  placeholder="{{ 'PROFILE.INPUT.LAST_NAME' | transloco }}"
                  formControlName="lastName"
                />
                <mat-error *ngIf="isControlHasError('lastName', 'required')">
                  <strong>{{ 'VALIDATION.REQUIRED_FIELD' | transloco }}</strong>
                </mat-error>
                <mat-error *ngIf="isControlHasError('lastName', 'minlength')">
                  <strong>{{ 'VALIDATION.MIN_LENGTH_FIELD' | transloco }} 3</strong>
                </mat-error>
                <mat-error *ngIf="isControlHasError('lastName', 'maxlength')">
                  <strong>{{ 'VALIDATION.MAX_LENGTH_FIELD' | transloco }} 100</strong>
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field>
                <mat-label>{{ 'PROFILE.INPUT.EMAIL' | transloco }}</mat-label>
                <input
                  matInput
                  type="email"
                  placeholder="{{ 'AUTH.INPUT.EMAIL' | transloco }}"
                  formControlName="email"
                  autocomplete="off"
                />
                <mat-error *ngIf="isControlHasError('email', 'required')">
                  <strong>{{ 'VALIDATION.REQUIRED_FIELD' | transloco }}</strong>
                </mat-error>
                <mat-error *ngIf="isControlHasError('email', 'email')">
                  <strong>{{ 'VALIDATION.INVALID_FIELD' | transloco }}</strong>
                </mat-error>
                <mat-error *ngIf="isControlHasError('email', 'minlength')">
                  <strong>{{ 'VALIDATION.MIN_LENGTH_FIELD' | transloco }} 3</strong>
                </mat-error>
                <mat-error *ngIf="isControlHasError('email', 'maxlength')">
                  <strong>{{ 'VALIDATION.MAX_LENGTH_FIELD' | transloco }} 320</strong>
                </mat-error>
              </mat-form-field>
            </div>

            <!--begin::Action-->
            <div class="kt-login__actions">
              <button
                (click)="submit()"
                id="kt_login_signin_submit"
                class="btn btn-primary btn-elevate kt-login__btn-primary"
                [ngClass]="{ 'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading }"
              >
                {{ 'AUTH.GENERAL.SUBMIT_BUTTON' | transloco }}
              </button>
            </div>
            <!--end::Action-->
          </form>
        </ng-template>
      </ngb-tab>

      <ngb-tab title="{{ 'PROFILE.TABS.CHANGE_PASSWORD' | transloco }}">
        <ng-template ngbTabContent>
          <form class="kt-login__form kt-form" [formGroup]="profileForm" autocomplete="off">
            <div class="form-group">
              <mat-form-field>
                <mat-label>{{ 'PROFILE.INPUT.CURRENT_PASSWORD' | transloco }}</mat-label>
                <input
                  matInput
                  type="password"
                  placeholder="{{ 'AUTH.INPUT.CURRENT_PASSWORD' | transloco }}"
                  formControlName="currentPassword"
                  autocomplete="off"
                />
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field>
                <mat-label>{{ 'PROFILE.INPUT.PASSWORD' | transloco }}</mat-label>
                <input
                  matInput
                  type="password"
                  placeholder="{{ 'PROFILE.INPUT.PASSWORD' | transloco }}"
                  formControlName="password"
                  autocomplete="off"
                />
                <mat-error *ngIf="isControlHasError('password', 'required')">
                  <strong>{{ 'VALIDATION.REQUIRED_FIELD' | transloco }}</strong>
                </mat-error>
                <mat-error *ngIf="isControlHasError('password', 'minlength')">
                  <strong>{{ 'VALIDATION.MIN_LENGTH_FIELD' | transloco }} 3</strong>
                </mat-error>
                <mat-error *ngIf="isControlHasError('password', 'maxlength')">
                  <strong>{{ 'VALIDATION.MAX_LENGTH_FIELD' | transloco }} 100</strong>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="form-group">
              <mat-form-field>
                <mat-label>{{ 'PROFILE.INPUT.CONFIRM_PASSWORD' | transloco }}</mat-label>
                <input
                  matInput
                  type="password"
                  placeholder="{{ 'PROFILE.INPUT.CONFIRM_PASSWORD' | transloco }}"
                  formControlName="passwordConfirmation"
                  autocomplete="off"
                />
                <mat-error *ngIf="isControlHasError('passwordConfirmation', 'required')">
                  <strong>{{ 'VALIDATION.REQUIRED_FIELD' | transloco }}</strong>
                </mat-error>
                <mat-error *ngIf="isControlHasError('passwordConfirmation', 'minlength')">
                  <strong>{{ 'VALIDATION.MIN_LENGTH_FIELD' | transloco }} 3</strong>
                </mat-error>
                <mat-error *ngIf="isControlHasError('passwordConfirmation', 'maxlength')">
                  <strong>{{ 'VALIDATION.MAX_LENGTH_FIELD' | transloco }} 100</strong>
                </mat-error>
                <mat-error
                  *ngIf="
                    profileForm.get('passwordConfirmation').errors &&
                    profileForm.get('passwordConfirmation').errors.ConfirmPassword
                  "
                >
                  <strong>{{ 'VALIDATION.CONFIRMATION_MISMATCH' | transloco }}</strong>
                </mat-error>
              </mat-form-field>
            </div>

            <!--begin::Action-->
            <div class="kt-login__actions">
              <button
                (click)="submit()"
                id="kt_login_signin_submit"
                class="btn btn-primary btn-elevate kt-login__btn-primary"
                [ngClass]="{ 'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading }"
              >
                {{ 'AUTH.GENERAL.SUBMIT_BUTTON' | transloco }}
              </button>
            </div>
            <!--end::Action-->
          </form>
        </ng-template>
      </ngb-tab>

      <ngb-tab title="{{ 'PROFILE.TABS.2FA' | transloco }}">
        <ng-template ngbTabContent>
          <mat-slide-toggle (change)="toggleTfa()" [formControl]="enableTfa">
            {{ 'PROFILE.ENABLE_TFA' | transloco }}
          </mat-slide-toggle>

          <div *ngIf="enableTfa.value && (tfaData | async)" class="mt-5">
            <div *ngIf="(tfaData | async).secret">
              <h5 style="border-bottom: 1px solid #a8a8a8; padding-bottom: 5px">Current Settings</h5>

              <!-- <img [src]="(tfaData | async).dataURL" alt="" class="img-thumbnail" style="display:block;margin:auto"> -->

              <p>Secret Key - {{ (tfaData | async).secret || (tfaData | async).tmpSecret }}</p>

              <p>Auth Type - Time Based - OTP</p>

              <button class="btn btn-lg btn-danger btn-block btn-signin" (click)="disableTfa()">Disable TFA</button>
            </div>

            <div *ngIf="!(tfaData | async).secret">
              <h5 style="border-bottom: 1px solid #a8a8a8; padding-bottom: 5px">Setup TFA</h5>

              <span *ngIf="!!(tfaData | async).tmpSecret">
                <p>Scan the QR code or enter the secret key in Google Authenticator</p>
                <img
                  [src]="(tfaData | async).dataURL"
                  alt=""
                  class="img-thumbnail"
                  style="display: block; margin: auto"
                />
                <p>Secret Key - {{ (tfaData | async).tempSecret }}</p>
                <p>Auth Type - Time Based - OTP</p>

                <form class="form-group" (ngSubmit)="verifyTfa()" #otpForm="ngForm">
                  <input
                    name="authcode"
                    type="text"
                    #iauthcode="ngModel"
                    class="form-control"
                    maxlength="6"
                    placeholder="Enter the Auth Code"
                    id="authcode"
                    autocomplete="off"
                    [(ngModel)]="authcode"
                    required
                  />
                  <br />
                  <button
                    type="Submit"
                    class="btn btn-lg btn-primary btn-block btn-signin"
                    [disabled]="iauthcode?.errors?.required"
                  >
                    Enable TFA
                  </button>
                </form>
              </span>
            </div>
          </div>
        </ng-template>
      </ngb-tab>
    </ngb-tabset>
  </kt-portlet-body>
</kt-portlet>
